const SERVICE_WORKER_PATH = "/notification-service-worker.js";

const urlBase64ToUint8Array = (value) => {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  const decoded = window.atob(base64);

  return Uint8Array.from(decoded, (character) => character.charCodeAt(0));
};

const serializeSubscription = (subscription) => {
  const value = subscription.toJSON();

  return {
    endpoint: value.endpoint,
    keys: {
      p256dh: value.keys?.p256dh,
      auth: value.keys?.auth,
    },
  };
};

export const getPushSubscription = async () => {
  if (!("Notification" in window) || !("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("Push notifications are not supported by this browser.");
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error(
      permission === "denied"
        ? "Notification permission was denied. Allow notifications in your browser settings to enable them."
        : "Notification permission is required to enable notifications."
    );
  }

  const registration = await navigator.serviceWorker.register(SERVICE_WORKER_PATH);
  const existingSubscription = await registration.pushManager.getSubscription();
  if (existingSubscription) return serializeSubscription(existingSubscription);

  const publicKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
  if (!publicKey) {
    throw new Error("Push notifications are not configured. Set REACT_APP_VAPID_PUBLIC_KEY.");
  }

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey),
  });

  return serializeSubscription(subscription);
};
